import {
    getBillingProvider,
    listBillingProviders
} from './queries';
import {
    createBillingProvider,
    deleteBillingProvider,
    updateBillingProvider,
    enableBillingProvider,
    disableBillingProvider,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateBillingProvider,
    DeleteBillingProvider,
    GetBillingProvider,
    ListBillingProviders,
    UpdateBillingProvider,
    EnableBillingProvider,
    DisableBillingProvider
} from "../types.ts";
import {
    CreateBillingProviderInput,
    UpdateBillingProviderInput
} from './buildBillingProviderInput';
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;


const normalizeFilter = (filter: { [key: string]: string }) =>
    Object.keys(filter).reduce((acc: { [key: string]: string }, key) => {
        if (filter[key] !== '' && filter[key] !== undefined) {
            acc[key] = filter[key];
        }
        return acc;
    }, {});

export const fetchRecords = async (query: ListRecordsQuery) => {
    const { filter, ...rest } = query;
    const transformedFilter = filter ? normalizeFilter(filter as { [key: string]: string }) : {};

    const response = await client.graphql<GraphQLQuery<ListBillingProviders>>({
                                                                                  query: listBillingProviders,
                                                                                  variables: {
                                                                                      ...rest,
                                                                                      ...(Object.keys(transformedFilter).length ? { filter: transformedFilter } : {})
                                                                                  },
                                                                              });


    return {
        items: response.data.listBillingProviders.items,
        nextToken: response.data.listBillingProviders.nextToken
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetBillingProvider>>({
                                                                                query: getBillingProvider,
                                                                                variables: {id: id},
                                                                            });
    return response.data?.getBillingProvider;
};

// The input is built by buildCreateBillingProviderInput / buildUpdateBillingProviderInput
// and sent as-is: the service never adds or strips keys.
export const add = async (input: CreateBillingProviderInput) => {
    const response = await client.graphql<GraphQLQuery<CreateBillingProvider>>({
                                                                                   query: createBillingProvider,
                                                                                   variables: {input},
                                                                               });
    return response.data?.createBillingProvider;
};

export const update = async (input: UpdateBillingProviderInput) => {
    const response = await client.graphql<GraphQLQuery<UpdateBillingProvider>>({
                                                                                   query: updateBillingProvider,
                                                                                   variables: {input},
                                                                               });
    return response.data?.updateBillingProvider;
};

export const enableRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<EnableBillingProvider>>({
        query: enableBillingProvider,
        variables: { id }
    });
    return response.data?.enableBillingProvider;
};

export const disableRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DisableBillingProvider>>({
        query: disableBillingProvider,
        variables: { id }
    });
    return response.data?.disableBillingProvider;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteBillingProvider>>({
                                                                                   query: (deleteBillingProvider),
                                                                                   variables: {input: {id: id}},
                                                                               });
    return response.data?.deleteBillingProvider;
};
